export enum ImagePosition {
    Top = 'top',
    Bottom = 'bottom',
    Left = 'left',
    Right = 'right',
}
